import { Icon, IconProps } from '@chakra-ui/react';

export function Smartphone(props: IconProps): JSX.Element {
  return (
    <Icon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.1667 0.841707L5.83332 0.833374C4.91666 0.833374 4.16666 1.58337 4.16666 2.50004V17.5C4.16666 18.4167 4.91666 19.1667 5.83332 19.1667H14.1667C15.0833 19.1667 15.8333 18.4167 15.8333 17.5V2.50004C15.8333 1.58337 15.0833 0.841707 14.1667 0.841707ZM14.1667 15.8334H5.83332V4.16671H14.1667V15.8334Z"
        fill="currentColor"
      />
    </Icon>
  );
}
